import { NotificationModule } from '@/store/modules/Notification'

export class NotificationUtil {
  static add(notification: string): void {
    NotificationModule.addNotification(notification)
  }
}
